<template>
  <span
    :class="[
      payment.transactionMethod === 'pos_card'
        ? 'bg-card'
        : payment.transactionMethod === 'pos_cash'
          ? 'bg-cash'
          : payment.transactionMethod === 'split'
            ? 'bg-primary'
            : 'bg-background-fg/40',
      large ? 'text-base' : 'text-xs',
    ]"
    class="inline-flex items-center justify-center rounded-full px-2 py-px text-background"
  >
    <template
      v-if="payment.transactionMethod === 'pos_card'"
    >
      <template v-if="cardSchemeIcon">
        <component
          :is="cardSchemeIcon"
          :class="payment.cardNumberLast4 ? 'mr-1' : ''"
        />
      </template>
      <span
        v-if="payment.cardNumberLast4?.trim()"
        class="ml-1"
      >
        {{ payment.cardNumberLast4 }}
      </span>
    </template>

    <template
      v-else-if="payment.transactionMethod === 'pos_cash'"
    >
      Cash
    </template>

    <template
      v-else-if="payment.transactionMethod === 'split'"
    >
      Split
    </template>

    <template v-else> - </template>
  </span>
</template>

<script setup lang="ts">
import type { TransactionMethod } from "@/services/sharedTypes/transactions"

const props = defineProps<{
  payment: {
    transactionMethod: TransactionMethod | "split" | null
    cardScheme?: string | null
    cardNumberLast4?: string | null
  }
  large?: boolean
}>()

const cardSchemeIcon = computed(() =>
  props.payment.cardScheme !== undefined
    ? getCardSchemeIcon(props.payment.cardScheme)
    : undefined
)
</script>
